import { IPm } from 'APIPackage/KnmModule/interfaces/IPm';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { IKnmPmForm } from '../interfaces/IKnmPmForm';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from '../../../KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { IKnmPmFormReason } from '../interfaces/IKnmPmFormReason';
import { isPlanKnm } from './isPlanKnm';

const isKnmIdLink = (knmIdLink: number | undefined) => (reason: IKnmPmFormReason) => {
  if (isPlanKnm(reason)) {
    return knmIdLink;
  }
};

export const convertReasonsFormValueToKnmData = (values: IKnmPmForm): IPm['reasons'] => {
  const { reasonsPm } = values;

  if (!reasonsPm) {
    return null;
  }

  return reasonsPm.map(item => ({
    reason: {
      id: item.reason?.id || null,
      guid: item.reason?.guid || null,
      ervkUuid: item.ervkUuid || item.type?.ervkUuid || null,
      title: item.reason?.title || item.type?.title || null,
      shortTitle: item.reason?.shortTitle || item.type?.shortTitle || null,
      type: item.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
      text: item.text || null,
      date: convertFormDateValueToKnmDataDate(item.date),
      main: item.reason?.main || null,
      approveRequired: item.reason?.approveRequired || null,
      assignmentNumber: item.order?.number || item.assignmentNumber || null,
      assignmentDate: convertFormDateValueToKnmDataDate(item.assignmentDate),
      requirementDetails: item.requirementDetails || null,
      dateRequirement: convertFormDateValueToKnmDataDate(item.dateRequirement),
      dateCreate: item.reason?.dateCreate || null,
      dateBegin: convertFormDateValueToKnmDataDate(item.dateBegin || item.type?.dateBegin),
      dateEnd: convertFormDateValueToKnmDataDate(item.dateEnd || item.type?.dateEnd),
      links: item.links || null,
      lastConductedKnmDate: convertFormDateValueToKnmDataDate(item.lastConductedKnmDate),
      flagProfvizit:
        typeof (item.type?.flagProfvizit || item.reason?.flagProfvizit) === 'boolean'
          ? Boolean(item.type?.flagProfvizit || item.reason?.flagProfvizit)
          : null,
      programAttachment: item.programAttachment || null,
      programNumber: item.programNumber || null,
      inspectionResults: item.inspectionResults,
    },
    order: item.order
      ? {
          ...item.order,
          date: convertFormDateValueToKnmDataDate(item.order.date) || '',
          checkBeginDate: convertFormDateValueToKnmDataDate(item.order.checkBeginDate) || '',
          checkEndDate: convertFormDateValueToKnmDataDate(item.order.checkEndDate) || '',
        }
      : null,
    knmIdLink: item.knmIdLink || isKnmIdLink(item.planKnm?.id)(item),
    riskIndicators:
      item.riskIndicators?.map(x => ({
        guid: x.guid,
        indicatorRiskAttachment: convertKnmDocumentAttachmentsFormValuesToKnmData(x.indicatorRiskAttachment) || null,
        indicatorRiskAuto: x.indicatorRiskAuto || null,
        riskIndicator: x.riskIndicator?.value || null,
        isNew: x.isNew,
      })) || null,
    numGuid: item.numGuid || null,
    dateCreate: item.dateCreate || null,
  }));
};
